import { SmartSort } from '@iheartjane/dm-sdk';
import { useMemo } from 'react';

import type { AlgoliaProduct } from '@jane/search/types';

export const useMemoizedRowInstance = (
  stringifiedSmartSortInstance: string | undefined
): SmartSort<AlgoliaProduct> | undefined => {
  return useMemo(() => {
    if (!stringifiedSmartSortInstance) {
      return undefined;
    }

    return SmartSort.fromJSON<AlgoliaProduct>(stringifiedSmartSortInstance);
  }, [stringifiedSmartSortInstance]);
};
